import { CalendarIconComponent, WlcmIconName, WlcmIcons } from '@wlcm/angular/core';
import { ArrowDownIconComponent } from '@shared/components/icons/arrow-down-icon/arrow-down-icon.component';
import { SearchIconComponent } from '@shared/components/icons/search-icon/search-icon.component';

export const WLCM_ICONS_CONFIG: WlcmIcons = {
  [WlcmIconName.SEARCH]: SearchIconComponent,
  [WlcmIconName.CALENDAR]: CalendarIconComponent,
  [WlcmIconName.CHEVRON_DOWN]: ArrowDownIconComponent,
};
